<template>
  <el-button v-bind="$attrs" :loading="btnLoading" @click="handle"><slot></slot></el-button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    // 防止以前使用cube-button有使用loading属性时失效情况
    loading: {
      type: Boolean,
      default: false
    },
    enableLoading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      btnLoading: this.loading
    }
  },
  methods: {
    handle() {
      if (this.enableLoading && typeof this.$listeners['click'] === 'function') {
        this.btnLoading = true
        const timer = setTimeout(() => {
          this.btnLoading = false
        }, 1000)
        this.$emit('click', () => {
          this.btnLoading = false
          clearTimeout(timer)
        })
      } else {
        this.$emit('click')
      }
    }
  }

}
</script>

